{
  "name": "simple-savings-guide",
  "version": "3.2.0.0",
  "scripts": {
    "watch": "ng test",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost-internal.sparbanken.me",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test --watch=false --code-coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.4",
    "@angular/common": "^21.1.4",
    "@angular/compiler": "^21.1.4",
    "@angular/core": "^21.1.4",
    "@angular/forms": "^21.1.4",
    "@angular/platform-browser": "^21.1.4",
    "@angular/platform-browser-dynamic": "^21.1.4",
    "@angular/router": "^21.1.4",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/core": "^21.1.4",
    "@angular-devkit/schematics": "^21.1.4",
    "@angular/build": "^21.1.4",
    "@angular/cdk": "^21.1.4",
    "@angular/cli": "~21.1.4",
    "@angular/compiler-cli": "^21.1.4",
    "@angular/material": "^21.1.4",
    "@sparbanken-syd/abasec": "^4.1.2",
    "@sparbanken-syd/auth-backend": "^2.5.3",
    "@sparbanken-syd/document-service": "^2.4.0",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/simple-savings-guide-be": "^3.1.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^21.0.1",
    "@sparbanken-syd/sparbanken-syd-qr": "^21.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^21.2.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^21.1.1",
    "@sparbanken-syd/teradata-user": "^3.1.0",
    "@types/jasmine": "~5.1.7",
    "@types/sinon": "^17.0.4",
    "angular-eslint": "^21.2.0",
    "baseline-browser-mapping": "^2.9.19",
    "eslint": "^9.28.0",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ngx-extended-pdf-viewer": "^25.6.4",
    "postcss": "^8.5.3",
    "puppeteer": "^24.37.3",
    "stylelint": "^16.19.0",
    "stylelint-config-sass-guidelines": "^12.1.0",
    "stylelint-config-standard-scss": "^14.0.0",
    "stylelint-scss": "^6.11.1",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.33.1"
  }
}
